import styled from "@emotion/styled";
import Box from "@mui/material/Box";

export const BroadcastChatsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`;
